import React, { Component } from 'react'
// import { makeStyles } from '@material-ui/styles'
import QrReader from 'react-qr-reader'
import { Grid, Button } from '@material-ui/core';
import Notifier, { openSnackbar } from 'components/Notifier';
import { makeStyles } from '@material-ui/styles';

// import classes from '*.module.sass';

// const useStyles = makeStyles(theme => ({
//   card: {
//     position: 'relative',
//     height: 512,
//     display: 'flex',
//     justifyContent: 'center',
//     backgroundColor: (theme.palette.type === 'dark') ? '#333' : '#fff',
//   },
//   container: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   },
//   item: {
//     flexBasis: '90%'
//   }
// }))

const useStyles = makeStyles(theme => ({
  scannedLink: {
    borderLeft: '2px solid green',
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 5,
    margin: 15,
    // backgroundColor: '#4CAF50(20%)',
    borderRadius: '5%'
    // opacity: 0.5
  }
})
)

const classesNameContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}

const previewStyle = {
  height: 240,
  width: 320,
}

function ScannedLink({ link, variant }) {
  const classes = useStyles()

  return (
    <div className={classes.scannedLink}>
      Link Identified:
      <a href={link} target="_blank" style={{ paddingLeft: 5 }}>
        {link}
      </a>
    </div>
  )
}

class QrCodeReader extends Component {
  state = {
    result: '',
    delay: 500,
    showQr: true,
  }

  validateQrData = data => { //Add more logic
    if (data.includes('https://')) {
      return true
    }
    return false
  }

  handleScan = data => {
    if (data) {
      this.setState({
        result: data
      })
    }
    if (!this.validateQrData(data)) {
      return
    }

    // console.log('aqui')
    // const msg = `Link Identified: <a href=${data} target="_blank" style="text-decoration:none">Open Form</a>`
    // openSnackbar({ message: msg, variant: 'success' })
    // window.open(
    //   this.state.result,
    //   '_blank' // <- This is what makes it open in a new window.
    // );
    // this.props.history.push('/')
  }
  // handleError = err => {
  // console.error(err)
  //   this.setState({
  // 	  result: err
  //   })
  // }
  render() {
    return (
      <Grid container direction="column" justify="space-between" alignContent="center">
        {this.state.showQr === true ?
          (<Grid item sm={8} style={{ width: '100%', maxWidth: 400 }}>
            {/* <div ></div> */}
            <QrReader
              delay={500}
              onError={this.props.handleError}
              onScan={this.handleScan}
            />
          </Grid>)
          :
          (<div>Reload it!</div>)
        }
        <Grid item sm={4}>
          {/* <p>{this.state.result}</p> */}
          {this.state.result === '' ?
            <p>Point the camera to the QR Code of the work within the marker.</p>
            :
            // ScannedLink({link: this.state.data})
            <ScannedLink link={this.state.result} />
          }
        </Grid>
        {/* <Button onClick={e => this.handleScan('https://goo.gl/DLsRGQ')}>Testando</Button> */}
        <Button onClick={e => this.setState({ showQr: !this.state.showQr })}>False</Button>
        {/* <Button onClick={e => this.setState({ delay: 500 })}>True</Button> */}
        {/* Error: */}

      </Grid>
    )
  }
}
export default QrCodeReader
